// extracted by css-extract-rspack-plugin
export default {"container":"j23PtHFnZAIYE0kS__container___"};